import { useLoader } from "../../contexts/loaderProvider";

export const YvooaPulseLoader = () => {
  const { isLoading, loaderText } = useLoader();

  if (!isLoading) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        backdropFilter: "blur(3px)",
        backgroundColor: "rgba(0,0,0,0.4)",
      }}
    >
      <div className="flex flex-col items-center justify-center p-5 rounded-lg bg-black bg-opacity-60">
        <div className="relative">
          {/* SVG Loader with Tailwind pulse */}
          <svg
            width={70}
            height={70}
            viewBox="0 0 120 120"
            className="animate-pulse"
          >
            <defs>
              <radialGradient id="coinFace" cx="50%" cy="50%" r="60%">
                <stop offset="0%" stopColor="#e3f2fd" stopOpacity="0.7" />
                <stop offset="50%" stopColor="#1976d2" stopOpacity="0.8" />
                <stop offset="100%" stopColor="#0d47a1" />
              </radialGradient>
              <linearGradient id="yGold" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#F9C642" />
                <stop offset="100%" stopColor="#FFD700" />
              </linearGradient>
            </defs>

            <circle cx="60" cy="60" r="50" fill="url(#coinFace)" />

            {/* Y Shape */}
            <polygon
              points="53,95 60,30 75,30"
              fill="#fff"
              className="drop-shadow-md"
            />
            <polygon
              points="35,30 55,55 50,75"
              fill="url(#yGold)"
              className="drop-shadow-md"
            />
          </svg>
        </div>

        <p className="mt-4 text-white text-lg font-medium">
          {loaderText || "Loading..."}
        </p>
      </div>
    </div>
  );
};
